//import React from "react";

export const AutoLogin = (props) => {
    return null;
}